import { useCouponsDetailsQuery } from '~/lib/Queries';
import React, { useEffect, useState } from 'react';
import useBusinessNavigate from '~/lib/useBusinessNavigate';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import * as Toast from '~/lib/Toast';
import CouponDetailsInput from '~/components/coupons/CouponDetailsInput';
import DiscountTypeInput from '~/components/coupons/DiscountTypeInput';
import AppliesToInput from '~/components/coupons/AppliesToInput';
import CouponLimitsInput from '~/components/coupons/CouponLimitsInput';
import ExpiresDateInput from '~/components/coupons/ExpiresDateInput';

const CouponEditForm = ({ couponId }) => {
    const { data: couponData } = useCouponsDetailsQuery(couponId);
    const [localData, setLocalData] = useState({});
    const [localCodes, setLocalCodes] = useState('');

    const navigate = useBusinessNavigate();

    const { save, isSaving } = useBusinessPostApi(`/coupons/${couponId}`);

    const codes = couponData?.codes || [];

    useEffect(() => {
        if (localData?.id !== couponId && couponData) {
            // Set the initial values
            if (couponData) {
                setLocalData(couponData?.coupon || {});
                setLocalCodes(codes.map(code => code.code).join('\n'));
            }
        }
    }, [couponId, JSON.stringify(couponData)]);

    function doSave(ev) {
        ev.preventDefault();

        save({
            coupon: localData,
            codes: localCodes,
        }).then(() => {
            Toast.success(`Successfully saved ${localData.name}`);
            navigate('/coupons');
        });
    }

    return (
        <form onSubmit={doSave}>
            <div className="panel-label">Coupon Details</div>
            <div className="panel mb-6">
                <CouponDetailsInput
                    name={localData?.name}
                    setName={value =>
                        setLocalData(old => ({ ...old, name: value }))
                    }
                    codes={localCodes}
                    setCodes={setLocalCodes}
                />
            </div>

            <div className="panel-label">Discount Type</div>
            <div className="panel mb-6">
                <DiscountTypeInput
                    value={localData.value}
                    onChange={newValue => {
                        setLocalData(old => ({ ...old, value: newValue }));
                    }}
                />
            </div>

            <div className="panel-label">Applies To</div>
            <div className="panel mb-6">
                <AppliesToInput
                    value={localData.applies_to}
                    onChange={newValue => {
                        setLocalData(old => ({ ...old, applies_to: newValue }));
                    }}
                />
            </div>

            <div className="panel-label">Usage Limit</div>
            <div className="panel mb-6 p-6">
                <CouponLimitsInput
                    value={localData.limits}
                    onChange={newValue => {
                        setLocalData(old => ({ ...old, limits: newValue }));
                    }}
                    codes={localCodes}
                />
            </div>

            <div className="panel-label">Expiration</div>
            <div className="panel mb-6">
                <ExpiresDateInput
                    value={localData.expires_at}
                    onChange={value =>
                        setLocalData(old => ({ ...old, expires_at: value }))
                    }
                />
            </div>

            <button type="submit" className="btn-save">
                {isSaving ? 'Saving...' : 'Save'}
            </button>
        </form>
    );
};

export default CouponEditForm;
